import React, { useCallback } from 'react';
import {
  AccessLevelInfoRequestForm,
  AccessLevelInfoRequestFormTypes,
} from '../../common/forms/AccessLevelInfoRequestForm';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import Btn from '../../../../components/molecules/Btn';
import { ModalDialogModifier } from '../../../../components/organisms/ModalDialog/ModalDialog.modifier';

type CurrentAccessLevelCreateFormProps = {
  createRequestForm: AccessLevelInfoRequestFormTypes;
};

export function CurrentAccessLevelCreateForm({ createRequestForm }: CurrentAccessLevelCreateFormProps) {
  const { t } = useSonTranslation('AccessLevel');

  const [showModal, setShowModal] = React.useState(false);
  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <div className="access-level__current-access-level-form">
      <Btn type="button" onClick={() => setShowModal(true)} cssClass="btn--single-action">
        {t('buttons.request')}
      </Btn>
      {showModal && (
        <ModalDialog
          closeModal={closeModal}
          headline={t('form.headline.create')}
          modifier={ModalDialogModifier.WITH_NAVIGATION}
        >
          <AccessLevelInfoRequestForm form={createRequestForm} />
        </ModalDialog>
      )}
    </div>
  );
}
